import {Component, inject, Input, OnChanges, SimpleChanges} from '@angular/core';
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {TeamNamePipe} from "../../../../shared/pipes/team-name.pipe";
import {GuessType} from "../../../../../backend/state/game-state.model";
import {GameStateStore} from "../../../../store/game-state.store";
import {guessOptionLabel} from "../../../game-guess/guess-option-label";
import {TeamGuessResult} from "../../../../../backend/messages/guess-result.message";


@Component({
  selector: 'app-team-guess-result',
  imports: [
    TranslateModule,
    TeamNamePipe
  ],
  providers: [
    TeamNamePipe
  ],
  templateUrl: './team-guess-result.component.html',
  styleUrl: './team-guess-result.component.scss'
})
export class TeamGuessResultComponent implements OnChanges {

  private readonly gameStore = inject(GameStateStore);

  @Input() showCorrect = false;

  @Input() result!: TeamGuessResult;

  details?: string;

  constructor(private translate: TranslateService,
              private teamName: TeamNamePipe) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!this.result) {
      return;
    }
    if (this.result.skipped) {
      this.details = this.translate.instant('game.guess.skipped');
      return;
    }
    const team = this.teamName.transform(this.result.team);
    switch (this.gameStore.guessType()) {
      case GuessType.CHRONOLOGICAL:
        this.details = this.getChronologicalDetails(team);
        break;
      case GuessType.DECADE:
        this.details = this.getDecadeDetails(team);
        break;
      case GuessType.DIFFERENCE:
        this.details = this.getDifferenceDetails(team);
        break;
      case GuessType.ARTIST:
      case GuessType.COUNTRY:
      case GuessType.BEFORE_AFTER:
      case GuessType.OLDER_NEWER:
        this.details = this.getOptionDetails(team);
        break;
    }
  }

  private getChronologicalDetails(team: string) {
    const guess = this.result.guess;
    let key: string = 'game.guess.types.CHRONOLOGICAL.result.between';
    if (!guess.minYear) {
      key = 'game.guess.types.CHRONOLOGICAL.result.before';
    } else if (!guess.maxYear) {
      key = 'game.guess.types.CHRONOLOGICAL.result.after';
    }
    return this.translate.instant(key, {...guess, team});
  }

  private getDecadeDetails(team: string) {
    return this.translate.instant('game.guess.types.DECADE.result', {decade: this.result.guess.minYear || 1920, team})
  }

  private getDifferenceDetails(team: string) {
    const diff = Math.abs(this.gameStore.activeHit()!.year - this.result.guess.minYear!);
    return this.translate.instant('game.guess.types.DIFFERENCE.result', {year: this.result.guess.minYear, team, diff})
  }

  private getOptionDetails(team: string) {
    const type = this.gameStore.guessType()!;
    const option = guessOptionLabel(type, this.result.guess.guessedOption ?? '',
      this.translate.currentLang || this.translate.defaultLang || 'en', key => this.translate.instant(key));
    return this.translate.instant(`game.guess.types.${type}.result`, {option, team})
  }
}
